import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { SiteResponse } from 'src/app/core/models/sites-management/site-response';

@Component({
  selector: 'app-dynamic-template-iframe',
  templateUrl: './dynamic-template-iframe.component.html',
  styleUrls: ['./dynamic-template-iframe.component.scss']
})
export class DynamicTemplateIframeComponent implements OnInit {
  @Input() siteData:SiteResponse;
  @Input() ifView:string;
  @Input() scrollTo:string;
  @Input() navigation:string;
  @Input() configVersion:string; 
  @Input() isExpanded: boolean = false; 

  trackId:string = "";
  url:string = "";

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
   this.trackId = this.generateRandomCode(8);
  }

  /*ngOnChanges(changes: SimpleChanges): void {
    if (changes['navigation'] && !changes['navigation'].firstChange) {
      this.trackId = this.generateRandomCode(8);
    }
  }*/

  getShopUrl(): string {
    // Build URL based on currently selected page (navigation)
    // Default to /home when navigation is undefined or contains the word "home"
    const base = this.siteData?.sub_domain || '';

    // Determine desired page path
    let pagePath = '/home';
    if (this.navigation && !this.navigation.toLowerCase().includes('home')) {
      // ensure leading slash and replace possible double dashes/underscores
      pagePath = `/${this.navigation}`;
    }

    // Remove a trailing slash from base to avoid double slashes
    const normalizedBase = base.endsWith('/') ? base.slice(0, -1) : base;

    // Compose final URL with query params to bust cache & show draft version
    this.url = `${normalizedBase}${pagePath}?template-status=DRAFT&preview-id=${this.trackId}`;

    return this.url;
  }

  generateRandomCode(length: number): string {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let code = '';
    for (let i = 0; i < length; i++) {
      code += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return code;
  }
}
